package games.polyclub.frontend.store.shared

import games.polyclub.message.Pronoun
import games.polyclub.service.config.api.SecretString
import games.polyclub.service.player.id.api.PlayerId
import games.polyclub.tool.functional.Option
import kotlinx.serialization.Serializable

@Serializable
data class RegisterRequest(
    val pronoun: Option<Pronoun>?,
    val brazilian: Boolean,
    val nick: String,
    val playerId: PlayerId?,
    val password: SecretString,
    val name: String,
    val lastName: String,
    val cpf: SecretString?,
    val email: SecretString,
    val captcha: SecretString,
    val agreeWithTerms: Boolean,
) {
}
